import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { reportNetworkFailure, reportNetworkSuccess } from '../resilience/networkHealth';

type Cfg = InternalAxiosRequestConfig & { _retried?: boolean };

export function createApiClient(o: { baseURL: string; getToken(): string | null; reauth(): Promise<string> }): AxiosInstance {
  const api = axios.create({ baseURL: o.baseURL, timeout: 15_000 });
  let inflight: Promise<string> | null = null;
  api.interceptors.request.use((c) => {
    const t = o.getToken();
    if (t) c.headers.set('Authorization', `Bearer ${t}`);
    return c;
  });
  api.interceptors.response.use(
    (r) => { reportNetworkSuccess(); return r; },
    async (e: AxiosError) => {
      const c = e.config as Cfg | undefined;
      if (!e.response) reportNetworkFailure();
      if (e.response?.status === 401 && c && !c._retried) {
        c._retried = true;
        inflight ??= o.reauth().finally(() => { inflight = null; });
        const token = await inflight;
        c.headers.set('Authorization', `Bearer ${token}`);
        return api.request(c);
      }
      throw e;
    },
  );
  return api;
}
